import { render, staticRenderFns } from "./area-well.vue?vue&type=template&id=68424ab4&scoped=true"
import script from "./area-well.vue?vue&type=script&lang=js"
export * from "./area-well.vue?vue&type=script&lang=js"
import style0 from "./area-well.vue?vue&type=style&index=0&id=68424ab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68424ab4",
  null
  
)

export default component.exports